import {useState} from "react";
import {Typography} from "@bonprix/design-system";

const SALE = "SALE";
const WOW = "Wow!-Preise";
const SUSTAINABILITY = "Nachhaltigkeit"; //nur für de und at gültig

export default function NavigationTeaserImage({teaserImageSource, title, textVariant}) {

    const [showFallbackImage, setShowFallbackImage] = useState(false);


    const fallbackImage = () => {
        let colorModifier = "";
        const isSale = title === SALE || title === WOW;
        // TODO: after A/B test set flag in backend to determine if picture is shown or not
        if (isSale || title === SUSTAINABILITY) {
            colorModifier = isSale ? "bg-clr-sale" : "bg-clr-sustainable";
        }

        return (
            <div className={`navigation__second-level-item-picture-title ${colorModifier}`}>
                <Typography component="div" color="on-primary-high"
                            variant={textVariant}>{title}</Typography>
            </div>
        );
    }

    const handleImageError = () => {
        setShowFallbackImage(true);
    }

    return (<>
        <div className="navigation__second-level-item-image-wrapper">
            {/* fallback image must always be rendered to prevent flickering when the image loading fails */}
            {/* will be overlaid by the actual image if it´s available */}
            {fallbackImage()}
            {!showFallbackImage && teaserImageSource?.src &&
                <img alt={teaserImageSource?.altText} className="navigation__second-level-item-image" onError={handleImageError}
                     src={teaserImageSource?.src}
                     srcSet={teaserImageSource?.srcSet} width="480" height="320"></img>
            }
        </div>
    </>);
}